// extracted by mini-css-extract-plugin
export default {"container":"AttachmentsView__container--rk6Zj","item":"AttachmentsView__item--EqVxp","preview":"AttachmentsView__preview--hQ0QP","actions":"AttachmentsView__actions--0Uh46"};